// src/components/Toast.js
import React, { useEffect } from "react";
import "./Toast.css";

const Toast = ({ message, type = "success", onClose }) => {
  useEffect(() => {
    if (type !== "loading") {
      const timer = setTimeout(() => {
        onClose();
      }, 3000); // auto close only for success/error

      return () => clearTimeout(timer);
    }
  }, [onClose, type]);

  return (
    <div className={`toast ${type}`}>
      {type === "loading" && <div className="spinner"></div>}
      <span>{message}</span>
    </div>
  );
};

export default Toast;
